module.exports = __webpack_public_path__ + "static/media/download.7f73af43.svg";